import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'fip-loading-spinner',
  templateUrl: './loading-spinner.component.html',
  styleUrls: ['./loading-spinner.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class LoadingSpinnerComponent {}
